import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestOrderFulfillmentPictureUploadUrlMutationVariables = Types.Exact<{
  file_type: Types.Scalars['String'];
  order_fulfillment_id?: Types.InputMaybe<Types.Scalars['ID']>;
  comment?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type RequestOrderFulfillmentPictureUploadUrlMutation = { __typename?: 'Mutation', requestOrderFulfillmentPictureUploadUrl: { __typename?: 'RequestOrderFulfillmentPictureUploadUrlResult', url: string, id: string } };


export const RequestOrderFulfillmentPictureUploadUrlDocument = gql`
    mutation RequestOrderFulfillmentPictureUploadUrl($file_type: String!, $order_fulfillment_id: ID, $comment: String) {
  requestOrderFulfillmentPictureUploadUrl(
    file_type: $file_type
    order_fulfillment_id: $order_fulfillment_id
    comment: $comment
  ) {
    url
    id
  }
}
    `;
export type RequestOrderFulfillmentPictureUploadUrlMutationFn = Apollo.MutationFunction<RequestOrderFulfillmentPictureUploadUrlMutation, RequestOrderFulfillmentPictureUploadUrlMutationVariables>;

/**
 * __useRequestOrderFulfillmentPictureUploadUrlMutation__
 *
 * To run a mutation, you first call `useRequestOrderFulfillmentPictureUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrderFulfillmentPictureUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrderFulfillmentPictureUploadUrlMutation, { data, loading, error }] = useRequestOrderFulfillmentPictureUploadUrlMutation({
 *   variables: {
 *      file_type: // value for 'file_type'
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRequestOrderFulfillmentPictureUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<RequestOrderFulfillmentPictureUploadUrlMutation, RequestOrderFulfillmentPictureUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOrderFulfillmentPictureUploadUrlMutation, RequestOrderFulfillmentPictureUploadUrlMutationVariables>(RequestOrderFulfillmentPictureUploadUrlDocument, options);
      }
export type RequestOrderFulfillmentPictureUploadUrlMutationHookResult = ReturnType<typeof useRequestOrderFulfillmentPictureUploadUrlMutation>;
export type RequestOrderFulfillmentPictureUploadUrlMutationResult = Apollo.MutationResult<RequestOrderFulfillmentPictureUploadUrlMutation>;
export type RequestOrderFulfillmentPictureUploadUrlMutationOptions = Apollo.BaseMutationOptions<RequestOrderFulfillmentPictureUploadUrlMutation, RequestOrderFulfillmentPictureUploadUrlMutationVariables>;